 $(document).ready(function() {
    $('.getstartbtn').on('click', function(e) {
        e.preventDefault(); // Prevent default link behavior

        // Get target ID from data-link attribute
        let target = $(this).data('link');

        // Add '#' if it's missing
        if (target && target[0] !== '#') {
            target = `#${target}`;
        }

        // Scroll to the target if it exists on the page
        if ($(target).length) {
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 800); // Adjust scroll speed as needed
        }
    });


//redirect-checkout code
if ($('.direct_checkout_btn').length) {
$('.product-info__buy-buttons button.direct_checkout_btn').on('click', function () {
        var button = $(this);
        var dataId = button.attr('data-id');
        var url = window.location.href;

        var variantMatch = url.match(/variant=(\d+)/);
        if (variantMatch) {
            dataId = variantMatch[1]; 
            button.attr('data-id', dataId);
        }

        var refillVariantId = '44457691316438';
        var refillSellingPlanId = '4782522582';

       
        var qtyInput = $('.quantity-selector input.quantity-selector__input[name="quantity"]');
        var qty = qtyInput.val() || 1; 

        var items = [
            { id: dataId, quantity: qty }
        ];

        if ($('#enable-auto-refill').is(':checked')) {
            items.push({
                id: refillVariantId,
                quantity: qty,
                selling_plan: refillSellingPlanId
            });
        }

        //console.log('Items array:', items);

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: items }),
            dataType: 'json',
            contentType: 'application/json',
            success: function () {
                window.location.href = '/checkout';
            },
            error: function (xhr, status, error) {
                alert('Error adding items to the cart. Please try again.');
                console.error(error);
            }
        });
    });
}
//end redirect-checkout-script



});